import { useTranslation } from "react-i18next";
import { navLinks, socialLinks } from "@/mocks/home";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-accent-950 text-background-100">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 px-4 md:px-6 py-14 md:py-16">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="flex items-center justify-center w-10 h-10 rounded-full border border-background-100/30 text-background-100">
              <i className="ri-film-line text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-bold text-background-50">
                {t("brand.name")}
              </span>
              <span className="font-label text-[11px] uppercase tracking-[0.22em] text-accent-200">
                {t("brand.tagline")}
              </span>
            </span>
          </div>
          <p className="text-sm leading-relaxed text-background-200 max-w-xs">
            {t("footer.about")}
          </p>
          <div className="flex items-center gap-3 mt-6">
            {socialLinks.map((social) => (
              <a
                key={social.id}
                href={social.href}
                target="_blank"
                rel="noreferrer"
                aria-label={social.label}
                className="flex items-center justify-center w-10 h-10 rounded-full bg-background-50/10 hover:bg-primary-500 hover:text-accent-950 text-background-100 transition-colors cursor-pointer"
              >
                <i className={`${social.icon} text-lg`}></i>
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-label text-sm uppercase tracking-[0.2em] text-accent-200 mb-5">
            {t("footer.explore")}
          </h3>
          <ul className="space-y-3">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={link.href}
                  className="text-sm text-background-100 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  {t(`nav.${link.id}`)}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-label text-sm uppercase tracking-[0.2em] text-accent-200 mb-5">
            {t("contact.title")}
          </h3>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-primary-300 mt-0.5">
                <i className="ri-map-pin-line text-lg"></i>
              </span>
              <span className="text-sm text-background-200">
                {t("contact.locationValue")}
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-primary-300 mt-0.5">
                <i className="ri-mail-line text-lg"></i>
              </span>
              <a
                href="mailto:hello@barewitness.com"
                className="text-sm text-background-100 hover:text-primary-300 transition-colors cursor-pointer"
              >
                {t("contact.emailValue")}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-100/15 px-4 md:px-6 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/80 text-center sm:text-left">
            {t("footer.rights")}
          </p>
          <p className="font-label text-xs uppercase tracking-[0.2em] text-accent-200">
            {t("footer.credit")}
          </p>
        </div>
      </div>
    </footer>
  );
}